import React from 'react';
import { Flex, Icon, Link } from '@chakra-ui/react';

const IconSocial = ({ icon, color, uri }) => {
  return (
    <Link href={uri} target="_blank">
      <Flex alignItems="center" cursor="pointer" p="3px" borderRadius={20} _hover={{ background: '#F6F6F6' }}>
        <Icon as={icon} color={color} fontSize="18px" />
        {/* <Text fontWeight="600">23</Text> <Text ml={1}>k</Text> */}
      </Flex>
    </Link>
  );
};
export default IconSocial;
